// Analysis.js
import React, { useEffect, useState, useRef } from 'react'
import HomeTabs from '../components/sub-components/HomeTabs'
import ChatInput from '../components/sub-components/ChatInput'
import Sidebar from '../components/sub-components/Sidebar'
import constants, { getInitials } from '../components/constants'
import { useThemeColor } from '../hooks/useThemeColor'
import { useOrganizationLogo } from '../hooks/useOrganizationLogo'
import ChatBlob from '../components/atomic/ChatBlob'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import Modal from '../components/sub-components/Modal'
import { fetchAIProfileByTaskAsync, selectAIProfile, selectAIProfileLoading } from '../slice/aiProfileSlice';
import { useSelector, useDispatch } from 'react-redux'
import { setHistoryId } from '../slice/storage'
import { fetchUserFiles } from '../slice/apiSlice'
import { fetchChatHistory } from '../slice/api/historySlice'
import { fetchQAHistory } from '../slice/qaHistorySlice'
import { clearChatHistory } from '../slice/chatSlice'
import { resetPdfUrl } from '../slice/pdfViewslice'
import { clearSources } from '../slice/sourceSlice'
import { renderToString } from 'react-dom/server';
import { fetchTaskByIdAsync, selectSelectedTask } from '../slice/taskSlice'
import ContentRenderer from '../components/ContentRenderer'
import markdownStyles from '../components/markdown-styles.module.css'

import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import rehypeSanitize from 'rehype-sanitize'
import { useToast } from '../components/Toast'

// Import the app styles
// eslint-disable-next-line import/no-webpack-loader-syntax
import appStyle from '!!css-loader?{"sourceMap":false,"exportType":"string"}!../App.css';

const Analysis = () => {

  const userId = localStorage.getItem('id');
  const { primaryColor } = useThemeColor();
  const { logoUrl, loading: logoLoading } = useOrganizationLogo();
  const { addToast, ToastContainer } = useToast();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true)
  const [sidebarWidth, setSidebarWidth] = useState(445);
  const [description, setDescription] = useState();
  
  // Load sidebar width from localStorage on component mount
  useEffect(() => {
    const savedWidth = localStorage.getItem('sidebarWidth');
    if (savedWidth) {
      const width = parseInt(savedWidth, 10);
      if (width >= 300 && width <= 800) {  // Validate width range
        setSidebarWidth(width);
      }
    }
  }, []);
  
  // Save width to localStorage when it changes
  const handleWidthChange = (newWidth) => {
    setSidebarWidth(newWidth);
    localStorage.setItem('sidebarWidth', newWidth.toString());
  };
  const [showScrollButton, setShowScrollButton] = useState(false);
  const chatContainerRef = useRef(null);
  const { chatHistory, loading } = useSelector((state) => state.chat);
  const openSidebar = () => setIsSidebarOpen(true)
  const closeSidebar = () => setIsSidebarOpen(false)
  const taskID = useSelector((state) => state.dropdown.id); 
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const chatHistoryData = useSelector((state) => state.history.chatHistory.history_records);
  const { userFiles, userFilesStatus, userFilesError } = useSelector((state) => state.api); 
  const { qaHistory, loading: qaLoading } = useSelector((state) => state.qaHistory);
  const [showSearchSection, setShowSearchSection] = useState(true)
  const toggleSearchSection = () => setShowSearchSection(prev => !prev)
  const taskData = useSelector(selectSelectedTask);
  const { historyId } = useParams();
  const [local_sidebarWidth, setLocalSidebarWidth] = useState(localStorage.getItem('sidebarWidth') || 445);
  // Create a ref to store all comments from ChatBlob components
  const globalCommentsRef = useRef({});

  // Function to update the global comments ref
  const updateGlobalComments = (messageId, commentText) => {
    if (messageId && commentText) {
      globalCommentsRef.current[messageId] = commentText;
    }
  };

  const aiProfile = useSelector(selectAIProfile);
  console.log(qaHistory, 'qa');

  useEffect(() => {
    dispatch(clearChatHistory());
  }, [dispatch]);

  useEffect(() => {
    if (historyId && userId) {
      dispatch(fetchChatHistory({ historyId, userId }));
    }
    // Cleanup function when component unmounts or historyId changes
    return () => {
      dispatch(clearChatHistory());
      dispatch(resetPdfUrl());
      dispatch(clearSources());
    };
  }, [dispatch, historyId, userId]);

  useEffect(() => {
    if (chatHistoryData?.task_id) {
      dispatch(fetchAIProfileByTaskAsync(chatHistoryData.task_id));
      dispatch(fetchQAHistory({ historyId, userId, taskId: chatHistoryData.task_id }));
    }
  }, [dispatch, chatHistoryData?.task_id, historyId, userId]);

  useEffect(() => {
    if (historyId && userId && chatHistoryData?.id) {
      dispatch(fetchUserFiles({ userId, taskId: chatHistoryData.id }));
    }
  }, [userId, historyId, chatHistoryData?.id, dispatch]);

  useEffect(() => {
    dispatch(setHistoryId(historyId));
  }, [historyId, dispatch]);

  // Auto-scroll to bottom when new messages are added
  useEffect(() => {
    scrollToBottom();
  }, [chatHistory, qaHistory]);
   
  const name = localStorage.getItem('name')
  
  const scrollToBottom = () => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTo({
        top: chatContainerRef.current.scrollHeight,
        behavior: 'smooth'
      });
    }
  };

  // const handleScroll = (e) => {
  //   const bottom = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight < 100;
  //   setShowScrollButton(!bottom);
  // };
  const handleScroll = (e) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight < 100;
    setShowScrollButton(!bottom);
};
  useEffect(() => {
    scrollToBottom();
  }, [qaHistory, chatHistory]);

  


  const exportChatsAsPDF = (includeComments = true) => {
    // Function to get the latest comments from all possible sources
    const getLatestComments = () => {
      const commentMap = {};
      
      // 1. First priority: Use comments from our global comments ref
      // This contains the most up-to-date comments from all ChatBlob components
      if (globalCommentsRef.current) {
        Object.entries(globalCommentsRef.current).forEach(([messageId, commentText]) => {
          if (messageId && commentText && commentText.trim() !== '') {
            commentMap[messageId] = commentText;
          }
        });
      }
      
      // 2. Second priority: Find comments in the DOM
      document.querySelectorAll('[data-comment-for]').forEach(commentEl => {
        const messageId = commentEl.getAttribute('data-comment-for');
        const commentText = commentEl.textContent;
        if (messageId && commentText && commentText.trim() !== '' && !commentMap[messageId]) {
          commentMap[messageId] = commentText;
        }
      });
      
      // 3. Third priority: Extract comments from chat history state
      // Only add comments that aren't already in our map
      qaHistory.forEach(message => {
        if (message.id && message.comment && message.comment.trim() !== '' && !commentMap[message.id]) {
          commentMap[message.id] = message.comment;
        }
      });
      
      chatHistory.forEach(message => {
        const messageId = message.id || (message.content && message.content.id);
        if (messageId && message.comment && message.comment.trim() !== '' && !commentMap[messageId]) {
          commentMap[messageId] = message.comment;
        }
      });
      
      return commentMap;
    };
    
    // Get the latest comments from all sources
    const latestComments = getLatestComments();
    console.log('Latest comments for PDF export:', latestComments);
    
    // Create the merged history with the latest comments
    const mergedHistoryForPDF = [...qaHistory, ...chatHistory].map(message => {
      // Get the message ID - ensure we're getting the correct ID
      let messageId;
      let originalComment = '';

      console.log(qaHistory,'message new')
      
      if (message.content && typeof message.content === 'object') {
        // For chatHistory messages
        messageId = message.id || message.content.id;
        originalComment = message.comment || '';
        
        
        // Try to find the comment in the DOM first
        const commentFromDOM = messageId && latestComments[messageId] ? latestComments[messageId] : '';
        
        return {
          id: messageId, // Store ID for debugging
          role: message.role,
          content: message?.content?.content,
          sources: message?.content?.source || [],
          timestamp: message.content.timestamp || new Date().toISOString(),
          name: message.name,
          comment: commentFromDOM || originalComment ,
          title:message.title
          // Prefer DOM comment, fall back to original,
          
        };
      } else {
        // For qaHistory messages
        messageId = message.id;
        originalComment = message.comment || '';
        
        // Try to find the comment in the DOM first
        const commentFromDOM = messageId && latestComments[messageId] ? latestComments[messageId] : '';
        
        return {
          id: messageId, // Store ID for debugging
          role: message.role,
          content: message.content,
          sources: message.sources || [],
          timestamp: message.timestamp,
          name: message.name,
          title:message.title,
          comment: commentFromDOM || originalComment // Prefer DOM comment, fall back to original
        };
      }
    });
    
    // Log the final merged history for debugging
    console.log('Merged history for PDF:', mergedHistoryForPDF.map(item => ({ id: item.id, comment: item.comment })));
    
    // Create a renderer for PDF export that exactly matches the main ContentRenderer component
    const SimpleContentRenderer = ({content }) => {
      
      // Function to process source references without using Redux
      const processSourceReferences = (text) => {
        if (!text) return text;
        
        // Regex to match source references
        const sourceRegex = /(Source:\s+)([^,]+\.pdf)(,\s+Page\s+)(\d+)/gi;
        
        // If no source references, return the original text
        if (!sourceRegex.test(text)) return text;
        
        // Split the text by the regex pattern
        const parts = text.split(sourceRegex);
        if (parts.length === 1) return text;
        
        // Reconstruct the text with the source references
        let result = '';
        for (let i = 0; i < parts.length; i++) {
          if (i % 5 === 0) {
            // This is regular text
            result += parts[i];
          } else if (i % 5 === 1) {
            // This is "Source: "
            result += parts[i];
          } else if (i % 5 === 2) {
            // This is the filename
            result += parts[i];
          } else if (i % 5 === 3) {
            // This is ", Page "
            result += parts[i];
          } else if (i % 5 === 4) {
            // This is the page number
            result += parts[i];
          }
        }
        
        return result;
      };
      
      // Process the content to ensure proper numbered list formatting
      const formattedContent = content ? content.replace(/^(\d+)[).]/gm, '$1.') : '';
      
      // Check if content contains HTML tables or markdown table syntax
      const hasHtmlTable = content && /<table[\s\S]*?<\/table>/i.test(content);
      const hasMarkdownTable = content && /\|[^\|]+\|/.test(content) && content.includes('\n');
      
      // Check if content is markdown
      const isMarkdownContent = content && (
        content.includes('##') || 
        content.includes('*') || 
        content.includes('```') || 
        content.includes('|') ||
        content.includes('Source:') ||
        content.includes('- ') ||
        content.includes('1. ')
      );
      
      // Apply both source reference processing and numbered list formatting
      const processedContent = processSourceReferences(formattedContent || content);
      
      // If content has HTML tables, render it as HTML with proper styling
      if (hasHtmlTable) {
        return <div className={markdownStyles.reactMarkDown} dangerouslySetInnerHTML={{ __html: content }} />;
      } else if (isMarkdownContent || hasMarkdownTable) {
        // Use ReactMarkdown with remarkGfm to properly render tables and other markdown elements
        return (
          <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            rehypePlugins={[rehypeSanitize]}
            className={markdownStyles.reactMarkDown}
            components={{
              // Override list item rendering to ensure no bold formatting
              li: ({node, ...props}) => <li style={{fontWeight: 'normal'}} {...props} />,
              // Ensure paragraphs inside list items aren't bold
              p: ({node, ...props}) => {
                // Check if this paragraph is inside a list item
                const isInListItem = node.parent && node.parent.tagName === 'li';
                return <p style={isInListItem ? {fontWeight: 'normal'} : {}} {...props} />;
              },
              // Ensure tables are properly styled
              table: ({node, ...props}) => <table style={{borderCollapse: 'collapse', border: '1px solid #e5e7eb', margin: '1rem 0'}} {...props} />,
              thead: ({node, ...props}) => <thead style={{backgroundColor: '#f9fafb'}} {...props} />,
              tbody: ({node, ...props}) => <tbody {...props} />,
              tr: ({node, ...props}) => <tr style={{borderBottom: '1px solid #e5e7eb'}} {...props} />,
              th: ({node, ...props}) => <th style={{border: '1px solid #e5e7eb', padding: '0.5rem 1rem', textAlign: 'left', fontWeight: '600'}} {...props} />,
              td: ({node, ...props}) => <td style={{border: '1px solid #e5e7eb', padding: '0.5rem 1rem'}} {...props} />
            }}
          >
            {processedContent}
          </ReactMarkdown>
        );
      }
      
      // For non-markdown content, just return the processed text
      return <div className='simple-answer'>{processedContent}</div>;
    };
    const additionalStyle = `
      body {
        font-family: Arial, sans-serif;
        overflow: visible;
        margin: 0;
        padding: 0;
      }
      .main-summary-card {
        width: 100%;
        margin: 0 auto;
        padding: 20px 40px;
        box-sizing: border-box;
      }
      @media print {
        body {
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }
        * {
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }
      }
      /* Ensure consistent table styling */
      table {
        border-collapse: collapse;
        width: 100%;
        margin: 1rem 0;
      }
      th, td {
        border: 1px solid #e5e7eb;
        padding: 8px 12px;
        text-align: left;
      }
      th {
        background-color: #f9fafb;
        font-weight: 600;
      }
      /* Ensure consistent list styling */
      ul, ol {
        padding-left: 2rem;
        margin: 1rem 0;
      }
      li {
        margin-bottom: 0.5rem;
      }
      /* Ensure consistent paragraph styling */
      p {
        margin: 0.75rem 0;
        line-height: 1.5;
      }
    `;

    // Function to convert image to data URL to avoid loading delays in print window
    const convertImageToDataURL = (imageUrl) => {
      return new Promise((resolve) => {
        if (!imageUrl || imageUrl.includes('aispaceslogo.png')) {
          // For default logo, return the original URL
          resolve(imageUrl);
          return;
        }
        
        const img = new Image();
        img.crossOrigin = 'anonymous'; // Enable CORS for external images
        
        img.onload = () => {
          try {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0);
            const dataURL = canvas.toDataURL('image/png');
            resolve(dataURL);
          } catch (error) {
            console.warn('Failed to convert image to data URL:', error);
            resolve(imageUrl); // Fallback to original URL
          }
        };
        
        img.onerror = () => {
          console.warn('Failed to load image:', imageUrl);
          resolve(imageUrl); // Fallback to original URL
        };
        
        img.src = imageUrl;
      });
    };

    // Convert logo to data URL to avoid loading delays
    convertImageToDataURL(logoUrl).then((processedLogoUrl) => {
      var printWindow = window.open();
      printWindow.document.write(`
        <html>
          <head>
            <title>AI Spaces KI-Zusammenfassung</title>
            <style>${appStyle}</style>
            <style>${additionalStyle}</style>
          </head>
          <body>
            ${renderToString(
              <div className="main summary-docai-data" id="summary-docai-data">
                <div className="main-summary-card">
                  {/* Header with logo */}
                  <div  style={{marginBottom: '10px', textAlign: 'start' }}>
                    <img 
                      src={processedLogoUrl}
                      alt="Logo"
                      style={{
                        height: '60px',
                        width: 'auto',
                        maxWidth: '200px',
                        objectFit: 'contain'
                      }}
                    />
                  </div>

                {/* Title Section */}
                <div style={{
                  backgroundColor: primaryColor,
                  padding: '15px 20px',
                  marginBottom: '20px',
                  borderRadius: '4px',
                
                }}>
                  <h1 style={{
                    margin: '0',
                    fontSize: '34px',
                    fontWeight: 'bolder',
                    color: 'white'
                  }}>{chatHistoryData?.history_name} KI-Zusammenfassung</h1>
                  
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img src={constants.pdfStar} style={{ height: '25px', width: '25px'}} alt="" />
                  <p style={{
                   marginLeft: '8px',
                    fontSize: '24px',
                    color: 'white'
                  }}>{chatHistoryData?.task_name}</p>
                  </div>
                </div>
                {/* Task Info Section */}
                <div style={{
                  display: 'flex',
                  gap: '20px',
                  borderBottom: '1px solid #ddd',
                }}>
                  
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <img src={constants.person} alt="" />
                    <h2>{name}</h2>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <img src={constants.calendar} alt="" style={{ height: '30px', width: '30px' }} />
                    <span>{new Date().toLocaleDateString()}</span>
    
                  </div>
                </div>

                {/* Uploaded Documents Section */}
                <div style={{ marginBottom: '30px' }}>
                  <h2 style={{ 
                    fontSize: '18px', 
                    fontWeight: 'bold',
                    marginBottom: '15px',
                    color: '#333'
                  }}>Hochgeladen Dokumente:</h2>
                  <div style={{ 
                    display: 'flex',
                     flexWrap: 'wrap',
                    gap: '8px'
                  }}>
                    {userFiles?.files?.map((file, index) => (
                      <div key={index} style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        padding: '8px 12px',
                        backgroundColor: '#f5f5f5',
                        borderRadius: '4px'
                      }}>
                        <img src={constants.file} alt="" style={{ height: '20px', width: '20px' }} />
                        <span style={{ fontSize: '14px' }}>{file.filename}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Questions & Answers Section */}
                <div style={{ marginBottom: '30px' }}>
                 
                  <div style={{ 
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '20px'
                  }}>
                    {mergedHistoryForPDF.map((chat, index) => (
                      <div key={index} style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '8px'
                      }}>
                        {/* Question title bar - similar to UI */}
                        {chat.role === 'user' && chat.title && (
                          <div style={{
                            backgroundColor: primaryColor,
                            color: 'white',
                            padding: '5px 15px',
                            borderRadius: '0.75rem',        // mb-2
                            width: 'fit-content',          // w-fit
                            paddingRight: '2.5rem',        // pr-10
                            paddingLeft: '2.5rem', 
                            marginBottom: '-8px',
                            fontWeight: 'bold',
                            fontSize: '16px',
                            width: 'fit-content'
                          }}>
                            {chat.title}
                          </div>
                        )}
                        {/* Question author styling */}
                        <div style={{
                          fontWeight: chat.role === 'user' ? 'bold' : 'normal',
                          color: '#333',
                          fontSize: '14px'
                        }}>
                          {chat.role === 'user' ? '' : ''}
                        </div>
                        {/* Question/Answer content box */}
                        <div style={{
                          backgroundColor: chat.role === 'user' ? '#f8f9fa' : '#fff',
                          padding: '12px 15px',
                          borderRadius: '4px',
                          fontSize: '14px',
                          lineHeight: '1.5',
                          border: '1px solid #eee',
                          marginBottom: includeComments && chat.comment ? '8px' : '0'
                        }}>
                          {/* Question/Answer content */}
                          <SimpleContentRenderer content={chat.content} />
                          {/* Sources for the question/answer if available */}
                          {chat.sources && chat.sources.length > 0 && (
                            <div style={{
                              marginTop: '8px',
                              fontSize: '12px',
                              color: '#2563eb'
                            }}>
                              {chat.sources.map((source, idx) => (
                                <div key={idx} style={{
                                  padding: '4px 8px',
                                  backgroundColor: '#f8fafc',
                                  borderRadius: '4px',
                                  marginTop: '4px'
                                }}>
                                  Source: {JSON.stringify(source)}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                        
                        {/* Display comments for the question/answer if available */}
                        {includeComments && chat.comment && chat.comment.trim() !== '' && (
                          <div
                            style={{
                              pageBreakInside: 'avoid',
                              display: 'block',
                              marginTop: '8px',
                              marginBottom: '16px',
                              padding: '8px 0',
                              minHeight: '40px',
                              background: 'none',
                            }}
                          >
                            <div
                              style={{
                                width: '32px',
                                height: '32px',
                                borderRadius: '50%',
                                backgroundColor: primaryColor,
                                color: 'white',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginRight: '12px',
                                fontSize: '12px',
                                fontWeight: 'bold',
                                verticalAlign: 'top',
                              }}
                            >
                              {getInitials(name)}
                            </div>
                            <div style={{ display: 'inline-block', verticalAlign: 'top', maxWidth: '80%' }}>
                              <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>
                                Kommentar von {name}
                              </div>
                              <div style={{ fontSize: '14px', color: '#333', wordBreak: 'break-word' }}>
                                
                                {chat.comment}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.print();
      });
  };

 

  const [searchType, setSearchType] = useState('vector');  

  const handleSearchTypeChange = (e) => {
    setSearchType(e.target.value);
  };

  const getSearchTypeIcon = (type) => {
    switch(type) {
      case 'hybrid':
        return '🔄'; // Sync icon for hybrid
      case 'simple':
        return '🔍'; // Magnifying glass for simple
      case 'vector':
        return '📊'; // Chart icon for vector
      default:
        return '🔍';
    }
  };

  const handleDescriptionSelect = (desc) => {
    setDescription(desc);
  };

  return (
    <div className="flex h-[calc(100vh-50px)] bg-white" >
      {/* Main content wrapper */}
      <div className={`flex flex-col flex-grow transition-all duration-300 relative`} >
        {/* Sidebar button - only visible when sidebar is closed */}
        {!isSidebarOpen && (
          <button 
            onClick={openSidebar}
            className="absolute flex w-full justify-end top-4 right-4 z-10 hover:opacity-80 transition-opacity duration-200"
          >
            <img src={constants.fold} alt="" />
          </button>
        )}
        
        {/* Header with button */}
        {/* <div className={`w-full p-4 flex justify-between items-center bg-white shadow-sm ${showSearchSection ? '' : 'hidden'}`}>
        <div className="ml-4 flex items-center gap-4">
            {/* Search Type Dropdown */}
            {/* <div className="flex items-center gap-2">
              <label htmlFor="searchType" className="text-sm font-medium text-gray-700 flex items-center gap-2">
                <span>{getSearchTypeIcon(searchType)}</span>
                Suche:
              </label>
              <select
                id="searchType"
                value={searchType}
                onChange={handleSearchTypeChange}
                className="block w-32 px-3 py-2 text-sm border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-custom-yellow focus:border-custom-yellow cursor-pointer hover:border-custom-yellow transition-colors duration-200"
              >
                <option value="hybrid">Hybrid-Suche</option>
                <option value="simple">Búsqueda-Suche</option>
                <option value="vector">Vektor-Suche</option>
              </select>
            </div> */}
            {/* Search type description tooltip */}
            {/* <div className="text-xs text-gray-500 italic">
              {searchType === 'hybrid' && 'Kombiniert Schlagworter mit semantischer Suche'}
              {searchType === 'simple' && 'Traditionelle Schlagwort-Suche'}
              {searchType === 'vector' && 'KI-basierte semantische Suche'}
            </div>
          </div>
          
          {!isSidebarOpen && (
            <button 
              onClick={openSidebar}
              className="hover:opacity-80 transition-opacity duration-200"
              style={{ zIndex: 30 }}
            >
              <img src={constants.fold} alt="" />
            </button>
          )}
        </div>

        {/* Main content area */} 
        <main className="flex-grow flex gap-5 flex-col items-starts overflow-y-auto mx-auto max-w-4xl no-scrollbar w-full relative" >
          <div 
            ref={chatContainerRef}
            onScroll={handleScroll}
            className="pt-10 pb-10 flex flex-col items-start justify-start gap-5 w-full chat-container overflow-y-auto "
          >
            {
            qaLoading ? (
                <div className="flex justify-center items-center">
                  <svg className="animate-spin h-8 w-8 text-custom-yellow" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                </div>
              ) : qaHistory?.map((message, index) => {
                return (
                <ChatBlob
                  historyId={chatHistoryData?.id}
                  taskId={chatHistoryData?.task_id}
                  key={index}
                  user={message.role}
                  message={{
                    id:message.id,
                    comment: message.comment,
                    content: message.content,
                    source: message.sources || [],
                    title: message.title || ''
                  }}
                  openSidebar={openSidebar}
                  onCommentUpdate={(commentText) => updateGlobalComments(message.id, commentText)}
                />
                );
              })
            }
            {chatHistory?.map((message, index) => {
              return (
              <ChatBlob
                historyId={chatHistoryData?.id}
                taskId={chatHistoryData?.task_id}
                key={index}
                user={message.role}
                message={{
                  comment: message.comment,
                  id:message.id,
                  context: message?.content?.context,
                  content: message.content,
                  source: message.sources || [],
                  title: message.title || ''
                }}
                openSidebar={openSidebar}
                onCommentUpdate={(commentText) => updateGlobalComments(message.id, commentText)}
              />
              );
            })}
            {loading && (
              <div className="flex justify-center items-center">
                <svg className="animate-spin h-8 w-8 text-custom-yellow" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
              </div>
            )}
          </div>
          {showScrollButton && (
            <button
              onClick={scrollToBottom}
              className="fixed bottom-24 left-8 bg-custom-yellow opacity-80 hover:bg-custom-yellow hover:opacity-100 text-white rounded-full p-3 shadow-lg transition-all duration-300 z-50"
            >
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                className="h-6 w-6" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M19 14l-7 7m0 0l-7-7m7 7V3" 
                />
              </svg>
            </button>
          )}
        </main>
        {/* Only one ChatInput at the bottom, responsible for all input, dropdown, and button logic */}
        <div className="pb-10">
          <ChatInput 
            onClick={exportChatsAsPDF} 
            historyId={chatHistoryData?.id || historyId} 
            taskName={chatHistoryData?.task_name} 
            project={chatHistoryData?.history_name}
            taskID={chatHistoryData?.task_id || taskID} 
            searchType={searchType} 
            prompt={description} 
            toggleSearchSection={toggleSearchSection}
          />
        </div>
      </div>

      {/* Sidebar */}
      <div 
        className="h-full transition-all duration-300 overflow-hidden"
        style={{ width: isSidebarOpen ? `${sidebarWidth}px` : '0' }}
      >
        <Sidebar 
          taskID={chatHistoryData?.task_id} 
          taskName={chatHistoryData?.task_name} 
          historyId={historyId} 
          onClose={closeSidebar} 
          isOpen={isSidebarOpen}
          onWidthChange={handleWidthChange}
          onDescriptionSelect={handleDescriptionSelect} 
        />
      
        {/* 
        <Modal isOpen={true}/> */}
      </div>
      <ToastContainer />
    </div>
  )
}

export default Analysis
